import React from "react";
import {
  ImageNews,
  InnerNewsCard,
  NewsCard,
  TextContainer,
  TypographyHeadline,
  TypographyRegular,
} from "./HomeDetails.styled";
import { useNavigate, useParams } from "react-router-dom";

const HomeNewsCard = ({ title, subTitle, imgSrc, onClick, mobileView }) => {
  const navigate = useNavigate();
  const { city } = useParams();

  const handleClick = () => {
    if (onClick) {
      // Use legacy onClick if provided
      onClick();
    }
    //  else if (title) {
    //   // Generate a slug from the title if not provided
    //   const slug = title
    //     .toLowerCase()
    //     .replace(/\s+/g, "-")
    //     .replace(/[^\w-]+/g, "");
    //   navigate(`/${city}/reader-detail/${slug}/${encodeURIComponent(title)}`, {
    //     state: {
    //       contentType: "News",
    //     },
    //   });
    // }
  };

  return (
    <NewsCard onClick={handleClick}>
      <ImageNews src={imgSrc} />
      <InnerNewsCard>
        <TypographyHeadline>{title}</TypographyHeadline>
        <TextContainer linenum={"3"}>
          <TypographyRegular minwidth="160px" lineHeight="20px" fontSize="13px">
            {subTitle}
          </TypographyRegular>
        </TextContainer>
      </InnerNewsCard>
    </NewsCard>
  );
};

export default HomeNewsCard;
